<template>
    <div class="c-row index-row w-100">
        <div class="c-tr">
            <div class="c-tw w-100">
                <div class="c-td index-options">
                    <the-btn
                        v-if="showExpandButton"
                        type="button"
                        class="px-0 expand-button"
                        :class="isExpanded ? '' : 'btn-custom-gray'"
                        @click="$emit('toggle-expand')"
                    >
                        <a-icon
                            :icon="isExpanded ? 'ArrowUp' : 'ArrowDown'"
                        />
                    </the-btn>
                </div>
                <div class="c-td index-checkbox">
                    <ui-checkbox-input
                        v-if="isCheckboxVisible"
                        :name="checkboxName"
                        :value="selected"
                        @input="$emit('update:selected', $event)"
                    />
                </div>
                <div class="c-td index-name">
                    <span
                        class="d-inline-block d-sm-block d-lg-none typo-label"
                    >
                        Nazwa produktu
                    </span>
                    <div
                        class="typo"
                        :class="isTypoSmall ? 'typo--sm' : 'typo--name typo--lg'"
                    >
                        {{ name }}
                    </div>
                </div>
            </div>
            <div class="c-tw">
                <div
                    v-if="showEan"
                    class="c-td index-ean"
                >
                    <span
                        class="d-inline-block d-sm-block d-lg-none typo-label"
                    >
                        Kod EAN
                    </span>
                    <div :class="{ 'typo--sm': isTypoSmall }">{{ ean }}</div>
                </div>
                <div class="c-td index-sap">
                    <span
                        class="d-inline-block d-sm-block d-lg-none typo-label"
                    >
                        Kod SAP
                    </span>
                    <div :class="{ 'typo--sm': isTypoSmall }">{{ sap }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        ean: {
            type: String,
            default: ''
        },
        sap: {
            type: String,
            required: true
        },
        showEan: {
            type: Boolean,
            default: false
        },
        showExpandButton: {
            type: Boolean,
            default: false
        },
        isExpanded: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
        checkboxName: {
            type: String,
            default: 'selectIndex'
        },
        isCheckboxVisible: {
            type: Boolean,
            default: true
        },
        isTypoSmall: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.c-row.index-row {
    margin: 0;
    .c-tw {
        align-items: flex-start;
        padding-right: 0;
        @include media-breakpoint-up(lg) {
            align-items: center;
        }
    }

    .c-tr {
        // Mobile layout with CSS Grid
        @include media-breakpoint-down(md) {
            display: grid;
            grid-template-columns: 50px 1fr;
            row-gap: 0.5rem;

            .c-tw:first-child {
                grid-column: 1 / -1;
                display: grid;
                grid-template-columns: 50px auto 1fr;
                gap: 0;
            }

            .c-tw:nth-child(2) {
                grid-column: 2;
            }
        }
    }

    .index-options {
        display: flex;
        align-items: center;
        justify-content: center;

        .expand-button {
            position: relative;
            // make sure the button is above connection line
            z-index: 1;
        }
    }

    .index-checkbox {
        order: 2;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        @include media-breakpoint-up(lg) {
            order: 0;
            justify-content: flex-start;
        }
    }
}
</style>
